export default __webpack_public_path__ + "static/media/work-sp.2aa24b54.webp";